var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("section", [
        _c("h3", { staticClass: "text-center" }, [
          _vm._v("สิทธิประโยชน์ของสมาชิกบีนีท")
        ]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            "  บีนีทเป็นผู้สร้างแพลตฟอร์มเทคโนโลยีเพื่อให้บริการต่างๆ เช่น บริการเกี่ยวกับบ้าน และ/หรือทำความสะอาดสำนักงาน บริการวางท่อประปา บริการระบบไฟฟ้า บริการทาสี บริการย้ายที่อยู่/ทำงาน รับจ้างทำงานเล็กๆ น้อยๆ หรืองานใดๆ ที่ปรากฏบนแพลตฟอร์มของบีนีทโดยบีนีทจะเป็นผู้จัดให้บริการบนบีนีทแฟลตฟอร์มซึ่งมีบริการที่หลากหลายตามแต่ความประสงค์ของลูกค้า\n"
          )
        ]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            "  บีนีทมีสิทธิพิเศษที่จะมอบให้แก่สมาชิกของบีนีทโดยเฉพาะเท่านั้น สมาชิกจะได้รับสิทธิพิเศษนับตั้งแต่จดทะเบียนสมัครสมัครและได้รับอนุมัติสถานภาพสมาชิกเป็นต้นไปโดยมีเสียค่าใช้จ่ายในการสมัคร 500 บาทซึ่งการเป็นสมาชิกจะมีสิทธิพิเศษดังนี้\n1. มีสิทธิได้รับการพิจารณาคัดเลือกเป็นผู้ให้บริการอิสระของบีนีทตามเงื่อนไขข้อตกลงการเป็นผู้ให้บริการอิสระที่บีนีทกำหนด ทั้งนี้สมาชิกอาจได้รับคัดเลือกให้เป็นผู้ให้บริการของบีนีทหรือไม่ก็ได้\n2. มีสิทธิในการเข้าอบรมการเป็นผู้ให้บริการอิสระของบีนีท ประเภทการบริการ\n3. สมาชิกจะได้รับเครื่องแต่งกายที่แสดงถึงอัตลักษณ์ของบีนีท\n4. มีสิทธิได้รับส่วนลดพิเศษในการซื้อผลิตภัณฑ์ของพันธมิตรต่างๆ บีนีท\n5. มีสิทธิ์ในการซื้อผลิตภัณฑ์ของบีนีทในราคาสมาชิก พร้อมสิทธิในการผ่อนชําระด้วยดอกเบี้ย 0%\n6. มีสิทธิได้รับการสะสมแต้มจากการซื้อผลิตภัณฑ์ของบีนีทเพื่อใช้เป็นส่วนลดพิเศษในการซื้อครั้งต่อไป\n7. มีสิทธิ์เข้าร่วมกิจกรรมต่างๆ ที่บีนีทจัดขึ้นเพื่อสมาชิกโดยเฉพาะ\n8. ได้รับการข่าวสารประชาสัมพันธ์ที่เป็นประโยชน์ต่างๆ จากบีนีทแพลตฟอร์ม\n9. ในกรณีฉุกเฉินจําเป็น บีนีทอาจให้บริการสินเชื่อส่วนบุคคลให้แก่สมาชิก\n10. สามารถใช้ wallet ของบีนีทบนบีนีทแพลตฟอร์มโดยไม่มีค่าใช้จ่าย (ระบบกําลังอยู่ระหว่างการดําเนินการ)\n\n  ทั้งนี้ บริษัทขอสงวนสิทธิไม่สามารถเปลี่ยนส่วนเป็นเงินสด และเงื่อนไขในแต่ละโปรโมชั่นอาจมีความเปลี่ยนแปลงแล้วแต่กรณี\n"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1100c59c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1100c59c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/contract/BenefitsDocument.vue
// module id = 1915
// module chunks = 0